// extracted by mini-css-extract-plugin
export default {"h":"style_h__D2Ym4","duo":"style_duo__IGpj+"};